/* assets/delay-scripts.js
   Load third-party scripts after first interaction OR after timeout.
*/
(() => {
  let loaded = false;

  const run = () => {
    if (loaded) return;
    loaded = true;

    document.querySelectorAll('script[data-lazy-src]').forEach((tag) => {
      const s = document.createElement('script');
      s.src = tag.dataset.lazySrc;
      s.async = true;
      if (tag.dataset.lazyId) s.id = tag.dataset.lazyId;
      document.head.appendChild(s);
      tag.remove();
    });

    document.dispatchEvent(new Event('thirdPartyScriptsLoaded'));
  };

  ['scroll', 'touchstart', 'mousemove', 'keydown', 'click'].forEach((evt) => {
    window.addEventListener(evt, run, { once: true, passive: true });
  });

  // Safety net: load anyway
  window.setTimeout(run, 6000);
})();
